export default __webpack_public_path__ + "static/media/text-yeti.6f533f1e.svg";